<script setup lang="ts">
  import { computed } from 'vue'
  import { text } from '@gat-ship/stakeholders'
  import {
    ModalSection,
    ModalSectionHeader,
    ModalSectionHeaderTitle,
    ModalSectionHeaderDescription
  } from '@gat-ship/vue-components'
  import StakeholderBtnRestore from '../../buttons/StakeholderBtnRestore.vue'
  import { useStakeholderContext } from '../../../composables/useStakeholder'

  const service = useStakeholderContext()
  const stakeholder = computed(() => service?.stakeholder.value)
</script>

<template>
  <ModalSection v-if="stakeholder && stakeholder.isInactive">
    <ModalSectionHeader>
      <ModalSectionHeaderTitle>
        {{ text.groups.restoreStakeholder(stakeholder.stakeholderType).title }}
      </ModalSectionHeaderTitle>
      <ModalSectionHeaderDescription>
        {{
          text.groups.restoreStakeholder(stakeholder.stakeholderType)
            .description
        }}
      </ModalSectionHeaderDescription>
    </ModalSectionHeader>
    <StakeholderBtnRestore :stake-holder="stakeholder" />
  </ModalSection>
</template>
